/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'renewal/users': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M1.412 15.716C2.334 14.641 3.62 14 5 14h8c1.38 0 2.666.64 3.588 1.716.917 1.07 1.412 2.493 1.412 3.95V22a1 1 0 11-2 0v-2.333c0-1.018-.348-1.97-.93-2.65C14.49 16.343 13.74 16 13 16H5c-.742 0-1.49.342-2.07 1.018-.582.68-.93 1.63-.93 2.649V22a1 1 0 11-2 0v-2.333c0-1.458.495-2.88 1.412-3.951zM9 4a3 3 0 100 6 3 3 0 000-6zM4 7a5 5 0 1110 0A5 5 0 014 7zM19.032 14.88a1 1 0 011.218-.718A5 5 0 0124 18.999v2a1 1 0 11-2 0v-1.998a3 3 0 00-2.25-2.903 1 1 0 01-.718-1.218zM15.031 2.882a1 1 0 011.217-.72 5 5 0 010 9.687 1 1 0 11-.496-1.938 3 3 0 000-5.812 1 1 0 01-.72-1.217z" _fill="currentColor"/>'
  }
})
